(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const triggerOffset = 100;
  let frameRequested = false;

  const enlargeNativeChatIcon = (chat) => {
    const root = chat.shadowRoot;
    if (!root || root.querySelector('#yiri-native-chat-icon-size')) return;

    const style = document.createElement('style');
    style.id = 'yiri-native-chat-icon-size';
    style.textContent = `
      .activator__icon,
      .activator__icon > svg {
        width: 24px !important;
        height: 24px !important;
        min-width: 24px !important;
      }
    `;
    root.appendChild(style);
  };

  const updateChatVisibility = () => {
    frameRequested = false;
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;

    enlargeNativeChatIcon(chat);
    const shouldShow = mobileQuery.matches && window.scrollY > triggerOffset;
    chat.classList.toggle('yiri-scroll-actions-visible', shouldShow);
  };

  const requestUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateChatVisibility);
  };

  const observeChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return false;

    enlargeNativeChatIcon(chat);
    updateChatVisibility();
    if (chat.shadowRoot) {
      new MutationObserver(() => enlargeNativeChatIcon(chat)).observe(chat.shadowRoot, {
        childList: true,
        subtree: true,
      });
    }
    new MutationObserver(requestUpdate).observe(chat, {
      attributes: true,
      attributeFilter: ['open'],
    });
    return true;
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  mobileQuery.addEventListener?.('change', requestUpdate);

  if (!observeChat()) {
    const observer = new MutationObserver(() => {
      if (observeChat()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
